import React from 'react';

/**
 * Reusable single-line input component with character counter
 * Used for alias editing, display name editing, etc.
 */
const SingleLineInput = ({
  value,
  onChange,
  onSave,
  onCancel,
  placeholder = 'Enter text...',
  maxLength,
  error,
  className = '',
  size = 'normal', // 'normal' or 'small'
  saving = false
}) => {
  const isSmall = size === 'small';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !saving) onSave?.();
    if (e.key === 'Escape') onCancel?.();
  };

  return (
    <div className={`space-y-1 ${className}`}>
      <div className={`flex ${isSmall ? 'gap-1' : 'gap-2'}`}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className={`flex-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            isSmall ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm'
          }`}
          maxLength={maxLength}
          autoFocus
        />
        <button
          onClick={onSave}
          disabled={saving}
          className={`bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 ${
            isSmall ? 'px-2 py-1 text-xs' : 'px-4 py-2 text-sm'
          }`}
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
        <button
          onClick={onCancel}
          disabled={saving}
          className={`bg-gray-300 text-gray-700 rounded hover:bg-gray-400 disabled:opacity-50 ${
            isSmall ? 'px-2 py-1 text-xs' : 'px-4 py-2 text-sm'
          }`}
        >
          Cancel
        </button>
      </div>
      {maxLength && (
        <div className="text-xs text-gray-500">
          {value.length}/{maxLength} characters
        </div>
      )}
      {error && (
        <div className={`text-red-600 ${isSmall ? 'text-xs' : 'text-sm'}`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default SingleLineInput;
